import { NgClass } from "@angular/common";
import { Component, input, InputSignal, signal, WritableSignal } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { ReportProcess } from "../../../../api/api.model";
import { InfoComponent } from "../../info/info.component";


@Component({
  selector: 'app-report-identification',
  standalone: true,
  imports: [
    TranslateModule,
    NgClass,
    MatIconModule,
    InfoComponent
  ],
  templateUrl: './report-identification.component.html',
  styleUrl: './report-identification.component.scss'
})
export class ReportIdentificationComponent {
  info: InputSignal<{ name: string, category: string, description: string }> = input.required();
  typeReport: InputSignal<ReportProcess> = input.required();

  public get typeReportKey(): string {
    switch (this.typeReport()) {
      case 'FIRST_REPORT':
        return 'first_report';
      case 'TOP_10':
        return 'top_10';
      case 'SUSPISIOUS_WALLET':
        return 'problem_wallets';
      default: {
        throw new Error("Not found type report");
      }
    }
  }

  public readonly stateClusterDetail: WritableSignal<boolean> = signal(false);

  public toggleRentalDetail(): void {
    this.stateClusterDetail.set(!this.stateClusterDetail());
  }
}
